import { render, staticRenderFns } from "./partner_entities_vime_activities.vue?vue&type=template&id=68b853c4"
import script from "./partner_entities_vime_activities.vue?vue&type=script&lang=js"
export * from "./partner_entities_vime_activities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports